import React, { useState, useEffect, createContext } from 'react';
import { housesData } from "../data";

export const HouseContext = createContext();

const HouseContextProvider = ({ children }) => {
    const [houses, setHouses] = useState(housesData);
    const [rentalType, setrentalType] = useState("Location (any)");
    const [countries, setCountries] = useState([]);
    const [property, setProperty] = useState('Property (any)');
    const [properties, setProperties] = useState([]);
    const [price, setPrice] = useState('Price range (any)');
    const [startDate, setStartDate] = useState('Rent Date (any)');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const allCountries = houses.map((house) => house.rentalType);
        const uniqueCountries = ['Location (any)', ...new Set(allCountries)];
        setCountries(uniqueCountries);
    }, [houses]);

    useEffect(() => {
        const allProperties = houses.map((house) => house.type);
        const uniqueProperties = ['Property (any)', ...new Set(allProperties)];
        setProperties(uniqueProperties);
    }, [houses]);

    const handleClick = () => {
        setLoading(true);
        const isDefault = (str) => str.split(' ').includes('(any)');
        const minPrice = parseInt(price.split(' ')[0]);
        const maxPrice = parseInt(price.split(' ')[2]);
        const dateSelected = parseInt(startDate);

        const newHouses = housesData.filter((house) => {
            const housePrice = parseInt(house.price);
            const houseAvailableDate = parseInt(house.date);

            if (house.rentalType === rentalType && house.type === property && housePrice >= minPrice && housePrice <= maxPrice && houseAvailableDate >= dateSelected) {
                return house;
            }

            if (isDefault(rentalType) && isDefault(property) && isDefault(price) && isDefault(startDate)) {
                return house;
            }

            if (!isDefault(rentalType) && isDefault(price) && isDefault(price) && isDefault(startDate)) {
                return house.rentalType === rentalType;
            }

            if (!isDefault(property) && isDefault(rentalType) && isDefault(price) && isDefault(startDate)) {
                return house.type === property;
            }

            if (!isDefault(price) && isDefault(rentalType) && isDefault(property) && isDefault(startDate)) {
                return housePrice >= minPrice && housePrice <= maxPrice;
            }

            if (!isDefault(startDate) && isDefault(rentalType) && isDefault(property) && isDefault(price)) {
                return houseAvailableDate >= dateSelected;
            }

            return false;
        });

        setTimeout(() => {
            setHouses(newHouses.length < 1 ? [] : newHouses);
            setLoading(false);
        }, 1000);
    }

    return (
        <HouseContext.Provider value={{
            rentalType,
            setrentalType,
            countries,
            property,
            setProperty,
            properties,
            price,
            setPrice,
            startDate,
            setStartDate,
            houses,
            loading,
            handleClick,
        }}>
            {children}
        </HouseContext.Provider>
    );
}

export default HouseContextProvider;